import React from 'react';
import styles from './SobreNos.module.css';

export default function SobreNos() {
    return (
        <h1>Aqui você encontra a pagina SObre nós!!!</h1>
    )
}
